import React, { useEffect, useState } from 'react';
import {
  Create,
  SimpleForm,
  useDataProvider,
  useNotify,
  Toolbar,
  SaveButton,
} from 'react-admin';
import { Snackbar, Alert } from '@mui/material';
import ConfigsFormFields from '../customForms/ConfigsFormFields';

const CustomToolbar = () => {
  const notify = useNotify();

  const onSuccess = (data) => {
    if (data?.message) {
      notify(data.message, { type: 'info' });
    } else {
      notify('Configuração criada com sucesso.', { type: 'info' });
    }
  };

  return (
    <Toolbar>
      <SaveButton mutationOptions={{ onSuccess }} />
    </Toolbar>
  );
};

const ConfigsCreate = () => {
  const dataProvider = useDataProvider();
  const [fileOptions, setFileOptions] = useState({ Pdfs: [], Images: [], Videos: [] });
  const [companyID, setCompanyID] = useState(undefined);
  const [allConfigs, setAllConfigs] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  // Default color values to ensure they are submitted even if unchanged
  const defaultColorValues = {
    primaryColor: '#000000',
    secondaryColor: '#9e9e9e',
    checkMarkColor: '#55e286',
    primaryTextColor: '#ffffff',
    secondaryTextColor: '#000000',
  };

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const result = await dataProvider.listFiles();
        const allFiles = [...(result.Pdfs || []), ...(result.Images || []), ...(result.Videos || [])];
        setFileOptions({
          Pdfs: allFiles.filter(f => f.toLowerCase().endsWith('.pdf')),
          Videos: allFiles.filter(f => f.toLowerCase().endsWith('.mp4')),
          Images: allFiles.filter(f => !f.toLowerCase().endsWith('.pdf') && !f.toLowerCase().endsWith('.mp4')),
        });
        setCompanyID(result.companyID);
      } catch (err) {
        console.error('Failed to fetch files', err);
        setErrorMessage('Erro ao carregar os ficheiros.');
        setSnackbarOpen(true);
      }
    };

    const fetchConfigs = async () => {
      try {
        const configsRes = await dataProvider.getList('configs', {
          pagination: { page: 1, perPage: 1000 },
          sort: { field: 'Name', order: 'ASC' },
          filter: {},
        });
        setAllConfigs(configsRes.data);
      } catch (err) {
        console.error('Failed to fetch configs:', err);
        setErrorMessage('Erro ao carregar as configurações.');
        setSnackbarOpen(true);
      }
    };

    fetchFiles();
    fetchConfigs();
  }, [dataProvider]);

  return (
    <>
      <Create title="Nova Configuração" redirect="edit">
        <SimpleForm
          toolbar={<CustomToolbar />}
          sanitizeEmptyValues
          warnWhenUnsavedChanges
          defaultValues={defaultColorValues}
        >
          <ConfigsFormFields
            fileOptions={fileOptions}
            companyID={companyID}
            allConfigs={allConfigs}
          />
        </SimpleForm>
      </Create>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity="error" onClose={() => setSnackbarOpen(false)}>
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ConfigsCreate;
